import React, { PureComponent } from "react";
import { View, Image } from "react-native";
import { Spacer } from "emrn-design/Spacer";

export class Dfcfzq extends PureComponent {
  render() {
    return (
      <View style={{ width: "100%", alignItems: "center" }}>
        <Spacer size={25} />
        <Image
          source={require("./dfcfzq.png")}
          style={{ width: 159, height: 35 }}
        />
        <Spacer size={20} />
      </View>
    );
  }
}
